<div class="reports-page-container">
  <div class="back-container" (click)="back()">
    <span nz-icon nzType="arrow-left" nzTheme="outline"></span><span>{{ 'symptomAssessment.symptomDetails.back' | translate }}</span>
  </div>
  <app-info-box title="{{ 'reportsPage.reports' | translate }}" description="{{ 'reportsPage.subtitle' | translate }}"></app-info-box>
  <h2>{{ 'reportsPage.folders' | translate }}</h2>
  <nz-divider></nz-divider>
  <div class="folders-container">
    @if (folderSquareContent && folderSquareContent.length > 0) {
      @for (folder of folderSquareContent; track folder.title; let last = $last) {
        <app-folder-square [folderSquareData]="folder" [ngClass]="last ? 'last-folder' : ''" (click)="handleClickFolders(folder.id)"></app-folder-square>
      }
    }
  </div>
  <h2>{{ 'reportsPage.recent_files' | translate }}</h2>
  <nz-divider></nz-divider>
  <div class="recent-files-container">
    @for (card of recentCardData; track recentCardData) {
      <app-document-card [documentCardData]="card" (emitActionCard)="actionCard($event)"></app-document-card>
    }
  </div>
  <div class="header">
    <h2>{{ 'reportsPage.all_documents' | translate }}</h2>
    <div class="links">
      <span (click)="downloadAll()"><img src="../../../../public/assets/images/downloadAll.svg" alt="" /> {{ 'buttons.downloadAll' | translate }}</span>
      <span (click)="shareAll()"><img src="../../../../public/assets/images/share.svg" alt="" /> {{ 'buttons.shareAll' | translate }}</span>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div class="all-documents-container">
    <app-appointments-table
      [searchEnabled]="true"
      [innerFiltersEnabled]="true"
      [hasCheckbox]="false"
      [hiddenLastSegment]="true"
      [columns]="columns"
      [appointments]="rows"
      [appointmentText]="appointmentsText"
      [innerSelectData]="innerSelectData"
      (actionClicked)="actionCard($event)"
    ></app-appointments-table>
  </div>
</div>
